import nlp from 'compromise';

// Function to extract contact number from resume text
function extractContactNumberFromResume(text) {
    const pattern = /(\b(?:(?:\+|00)\s?\d{1,3}[\s.-]?)?(?:?\d{1,4}?[\s.-]?)?\d{1,4}(?:[\s.-]?\d{1,4}){1,3}\b)/;
    const match = text.match(pattern);
    return match ? match[0] : null;
}

// Function to extract email from resume text
function extractEmailFromResume(text) {
    const pattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/;
    const match = text.match(pattern);
    return match ? match[0] : null;
}

// Function to extract skills from resume text
function extractSkillsFromResume(text, skillsList) {
    return skillsList.filter(skill => new RegExp(`\\b${skill}\\b`, 'i').test(text));
}

// Function to extract education from resume text
function extractEducationFromResume(text) {
    const pattern = /(?:Bsc|\bB\.\w+|\bM\.\w+|\bPh\.D\.\w+|\bBachelor(?:'s)?|\bMaster(?:'s)?|\bPh\.D)\s(?:\w+\s)*\w+/i;
    return text.match(pattern) || [];
}

// Function to extract name from resume text
function extractName(resumeText) {
    const doc = nlp(resumeText);
    const people = doc.people().out('array');
    return people.length > 0 ? people[0]: null;
}

function parseWorkExperience(text) {
    const startKeywords = ["Work Experience", "Professional Experience", "Employment History", "Research & Work Experience"];
    const stopKeywords = ["Projects", "Education", "Skills", "Technical Skills", "Certifications", "Publications", "Teaching Experience"];

    // Find start
    let startIndex = -1;
    for (const keyword of startKeywords) {
        const idx = text.indexOf(keyword);
        if (idx !== -1 && (startIndex === -1 || idx < startIndex)) {
            startIndex = idx;
        }
    }
    
    if (startIndex === -1) return [];
    text = text.substring(startIndex);

    // Find stop
    let endIndex = text.length;
    for (const stopKeyword of stopKeywords) {
        const idx = text.indexOf(stopKeyword);
        if (idx !== -1 && idx < endIndex) {
            endIndex = idx;
        }
    }
    
    text = text.substring(0, endIndex).trim();
    console.log("Extracted text section:", text); // Debug

    // Original pattern with minor modifications
    const jobEntryPattern = /(?<date_range>(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{4}\s*-\s*(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{4})\s*(?<job_title>[^,]+),\s*(?<company>[^\n]+)\s*(?<description>(?:(?!\n(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)).[^\n]*\n?)*)/gi;
    
    const experiences = [];
    let match;

    while ((match = jobEntryPattern.exec(text)) !== null) {
        console.log("Found match:", match.groups); // Debug
        
        let {job_title, date_range, company, description} = match.groups;
        
        // Clean fields
        job_title = job_title.trim();
        company = company.trim();
        date_range = date_range.trim();
        description = description ? description.trim() : null;

        if (job_title && company) {
            experiences.push({
                job_title,
                date_range,
                company,
                description
            });
        }
    }

    return experiences;
}

export async function getParsedResume(fileContent) {
    try{
        const text = fileContent;

        const name = extractName(text);
        const contactNumber = extractContactNumberFromResume(text);
        const email = extractEmailFromResume(text);
        const skillsList = ['Python', 'Data Analysis', 'Machine Learning', 'Communication', 'Project Management', 'Deep Learning', 'SQL', 'Tableau', 'C', 'Java', 'Javascript', 'React', 'MongoDB'];
        const extractedSkills = extractSkillsFromResume(text, skillsList);
        const extractedEducation = extractEducationFromResume(text);
        const extractedExperiences = parseWorkExperience(text);
        if (extractedExperiences.length) {
            extractedExperiences.forEach(exp => console.log(exp));
        } else {
            console.log("No experiences found");
        }

        return {
            text,
            name,
            contactNumber,
            email,
            skills: extractedSkills,
            education: extractedEducation,
            experiences: extractedExperiences
        };
    } catch (error) {
        console.error('Error parsing resume:', error);
        return error;
    }
};